import '@babel/polyfill'
import 'array-flat-polyfill'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { mapGetters } from 'vuex'
import { handleCriticalError } from '@/services/ErrorHandler'

require('./routerGuards')
require('./bootstrap/globalComponents')
require('./bootstrap/prototypeProperties')
require('./bootstrap/plugins')
require('./bootstrap/filters')
global.jQuery = global.$ = require('jquery')

const errorRE = /(Loading chunk .* failed|expected expression, got '<'|unexpected token '<')/
window.onerror = handleCriticalError(errorRE)

router.onError(handleCriticalError(errorRE))

Vue.mixin({
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('user', ['isOwnedByUser'])
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
